import {
    UserSystemIdState,

    FetchState
} from "@/shared/types";
import {
    getUserSystemId,
    setUserSystemId
} from "@/shared/api/bankService";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: UserSystemIdState = {
    fetchState: FetchState.Uninitialized,
    username: null,
    needsSystemId: false,
    userSystemId: null
};

export const useUserSystemIdStore = defineStore("userSystemId", {
    state: (): UserSystemIdState => (_.cloneDeep(initialState)),
    actions: {
        setNeedsSystemId (newValue: boolean) {
            this.needsSystemId = newValue;
        },
        setUsername (username: string) {
            this.username = username;
            this.fetchState = FetchState.Uninitialized;
        },
        setFetchState (fetchState: FetchState) {
            this.fetchState = fetchState;
        },
        setUserSystemId (newValue: string) {
            this.userSystemId = newValue;
        },
        loadUsername ({ partnerId, username }: { partnerId: number, username: string }) {
            this.setUsername(username);
            this.setFetchState(FetchState.Loading);
            return getUserSystemId(partnerId, username)
                .then(response => {
                    // TODO: double-check that 404 response results in error, not this code path!
                    this.setNeedsSystemId(response.data.custodianRequresSystemId);
                    this.setUserSystemId(response.data.userSystemId);
                    this.setFetchState(FetchState.Loaded);
                })
                .catch(err => {
                    if (err.response.status !== 404) {
                        storeHelper.handleError({ error: err, rethrow: true });
                    }
                    this.setNeedsSystemId(false);
                    this.setFetchState(FetchState.Loaded);
                });
        },
        beginSetUserSystemId ({ partnerId, userSystemId }: { partnerId: number, userSystemId: string }) {
            if (!this.username || !this.needsSystemId) {
                return Promise.resolve();
            }

            this.setFetchState(FetchState.Loading);
            return setUserSystemId(partnerId, this.username, userSystemId)
                .then(response => {
                    // TODO: double-check 400 response results in error not this code path!
                    this.setUserSystemId(response.data);
                    this.setFetchState(FetchState.Loaded);
                })
                .catch(err => {
                    this.setFetchState(FetchState.Loaded);
                    return storeHelper.handleError({ error: err, rethrow: true });
                });
        }
    }
});
